import { Set } from "immutable"

export const keyIn = (...keys) => {
  const keySet = Set(keys)
  return (v, k) => keySet.has(k)
}

export const iGet = (prop: string | Array<string>) => x =>
  Array.isArray(prop) ? x.getIn(prop) : x.get(prop)
